import * as React from "react";
import type {IFieldDataTypeSettingsProps} from "../../modules/settings/modules/field/datatypes/IFieldDataTypeSettingsProps";
import {FieldV5} from "./FieldV5";
import {TextInputV5} from "./datatypes/TextInputV5";

export interface IBooleanFieldSettingsDefinition {
	displayLabelForTrue: string;
	displayLabelForFalse: string;
}

export class BooleanFieldSettingsV5 extends React.Component<IFieldDataTypeSettingsProps> {
	private onEditWhenFalse = (value: string) => {
		const {field, onChange} = this.props;
		const settings = field.dataTypeSettings as IBooleanFieldSettingsDefinition;

		settings.displayLabelForFalse = value;
		onChange();
	};

	private onEditWhenTrue = (value: string) => {
		const {field, onChange} = this.props;
		const settings = field.dataTypeSettings as IBooleanFieldSettingsDefinition;

		settings.displayLabelForTrue = value;
		onChange();
	};

	private getErrorMessageWhenTrue = (value: string) => {
		return !value.trim() ? "Value cannot be empty" : value === this.props.field.dataTypeSettings.displayLabelForFalse ? "Value must be unique" : "";
	};

	private getErrorMessageWhenFalse = (value: string) => {
		return !value.trim() ? "Value cannot be empty" : value === this.props.field.dataTypeSettings.displayLabelForTrue ? "Value must be unique" : "";
	};

	public override render() {
		const {displayLabelForTrue, displayLabelForFalse} = this.props.field.dataTypeSettings as IBooleanFieldSettingsDefinition;

		return (
			<>
				<FieldV5 label="Value when true">
					<TextInputV5
						value={displayLabelForTrue}
						onChange={this.onEditWhenTrue}
						getErrorMessage={this.getErrorMessageWhenTrue}
						className="infoBubbleAlignLeft"
					/>
				</FieldV5>
				<FieldV5 label="Value when false">
					<TextInputV5
						value={displayLabelForFalse}
						onChange={this.onEditWhenFalse}
						getErrorMessage={this.getErrorMessageWhenFalse}
						className="infoBubbleAlignLeft"
					/>
				</FieldV5>
			</>
		);
	}
}
